import React, {useContext, useState, useEffect} from 'react'
import { useSearchParams } from 'react-router-dom';
import AuthLayout from "../../templates/auth-templates";
import ImgLoginPanel from "../../assets/images/auth/img-auth-1.jpg"
import Logo from "../../components/Logo/Logo";
import Alert from '../../components/Alert/Alert'; 
import AuthContext from '../../context/AuthContext'  
import { Link } from 'react-router-dom';
const ChangePass  = () => { 
    let { errorMessage , passChange} = useContext(AuthContext)  
    let [tokenValue, setTokenValue] = useState('')
    const [searchParams] = useSearchParams();

    useEffect(()=> {  
        setTokenValue(searchParams.get('token'))
    }, )

    return (
      <AuthLayout>   
        <div className="col-md-7">
          <div className="card-body">
            <div className="mb-4">
              <Logo/>
            </div>
            <h4 className="mb-3 f-w-400">Change password</h4> 
            {errorMessage && <Alert>Error</Alert>}
            <form onSubmit={passChange}>
            <div className="form-group mb-2"> 
              <input 
                type="password" 
                className="form-control" 
                name="newpass"
                placeholder="New Password"
              />
            </div> 
            <div className="form-group mb-2"> 
              <input 
                type="password" 
                className="form-control" 
                name="newpass2"
                placeholder="Confirm Password"
              />
            </div> 
            
              <input type="hidden" name="id" value={tokenValue}/>
         
            <button type="submit" className="btn btn-orange" >Change Password</button> 
            <p className="mt-2 mb-2 text-muted">I have account? <Link to='/login' className="f-w-400">Login</Link> </p>
            </form>
          </div>
          
        </div>  
        <div className="col-md-5 d-none d-md-block">
          <img src={ImgLoginPanel} alt="login" className="img-fluid" />
        </div> 
      </AuthLayout>
    )
}

 

export default ChangePass  